<div class="password-criteria" [class.password-criteria--expanded]="expanded" aria-live="polite">
  <div class="password-criteria__inner">
    <p>
      <span class="password-criteria__mark">{{ !this.details || (!!this.details.hasMinLength && !!this.details.hasMaxLength) ? '✅' : '❌' }}</span>
      {{ 'auth.passwordSet.requirementLength' | translate: {min: PASSWORD_MIN_LENGTH, max: PASSWORD_MAX_LENGTH} }}
    </p>
    <p>
      <span class="password-criteria__mark">{{ !this.details || (!!this.details.hasUpper && !!this.details.hasLower) ? '✅' : '❌' }}</span>
      {{ 'auth.passwordSet.requirementCase' | translate }}
    </p>
    <p>
      <span class="password-criteria__mark">{{ !this.details || !!this.details.hasSpecial ? '✅' : '❌' }}</span>
      {{ 'auth.passwordSet.requirementSpecial' | translate }}
    </p>
    <p>
      <span class="password-criteria__mark">{{ !this.details || !!this.details.hasNumber ? '✅' : '❌' }}</span>
      {{ 'auth.passwordSet.requirementNumber' | translate }}
    </p>
  </div>
</div>
